import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'
import {
  isK5Dashboard,
  isMiddleSchoolDashboard,
} from 'utils/routing/routeHelpers'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20164-k5-site-selection'],
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  OnComponent,
  OffComponent,
  onCondition: (_, subscribedFlags) => {
    const isMiddleSchool = isMiddleSchoolDashboard()

    const isK5 =
      isK5Dashboard() &&
      subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return isMiddleSchool || isK5
  },
})

export default FlagToggler
